<template>
  <div class="user">
    <div class="user__info">
      <div class="user__name">
        <p>{{ userName }}</p>
        <p>{{ user.network_name }}</p>
      </div>
      <div class="user__menu">
        <b-icon icon="chevron-down"></b-icon>
      </div>
    </div>
    <div class="user__dropdown">
      <ul>
        <li>{{ user.email }}</li>
        <router-link :to="{ name: 'site.my-info' }" tag="li">
          <b-icon size="is-small" icon="account"></b-icon>Meus Dados
        </router-link>
        <li @click="onClickLogout">
          <b-icon size="is-small" icon="logout"></b-icon>Sair
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { AUTH_LOGOUT } from '@/store/actions/auth';

export default {
  name: 'app-navbar-user',
  data: () => {
    return {
      defaultPicture: require('@/assets/img/default_user.png'),
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    userName() {
      return this.user.name.split(' ').slice(0, 2).join(' ');
    },
  },
  methods: {
    onClickLogout() {
      this.$buefy.dialog.confirm({
        message: 'Tem certeza que deseja sair do sistema?',
        cancelText: 'Cancelar',
        confirmText: 'Sim, sair',
        type: 'is-primary',
        onConfirm: () => this.logout(),
      });
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$route.path !== '/' && this.$router.push('/');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding-left: 12px;
  border-left: 1px solid #eee;

  &__name {
    margin-right: 24px;

    p {
      margin: 0;

      &:first-child {
        font-weight: 500;
        font-size: 0.9em;
      }

      &:last-child {
        color: var(--text-color-light);
        font-weight: 300;
        font-size: 0.8em;
      }
    }
  }

  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    &:hover {
      ~ .user__dropdown {
        display: unset;
      }
    }
  }

  &__menu {
    display: flex;
    align-items: center;
    cursor: pointer;

    .picture {
      height: 56px;
      width: 56px;
      border-radius: 50%;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }

  &__dropdown {
    display: none;
    position: absolute;
    top: 99%;
    right: 16px;
    padding-top: calc(1% + 16px);

    &:hover {
      display: unset;
    }

    ul {
      background: #fff;
      min-width: 250px;
      border-radius: 8px;
      box-shadow: 0 2px 14px rgba(0, 0, 0, 0.1);

      li {
        padding: 16px;

        .icon {
          margin-right: 6px;
        }

        &:first-child {
          font-size: 0.9em;
          color: #828282;
          border-bottom: 1px solid #e3e4e6;
        }

        &:not(:first-child) {
          cursor: pointer;

          &:hover {
            background: rgba(0, 0, 0, 0.02);
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .user {
    flex-direction: column;
    margin-top: 2em;
    padding: 0;
    border: 0;

    &__info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .icon {
        display: none;
      }
    }

    &__dropdown {
      position: static;
      display: unset;
      width: 100%;
    }
  }
}
</style>
